import Vue from "vue";
import Router from "vue-router";
// import {Notify} from 'vant';
// import superManager from '@/views/managerDay/superManager.js';

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Share",
    component: () => import('@/layout/index.vue'),
    redirect: "/login",
    children: [
      {
        path: "/share/detail",
        name: "ShareDetail",
        component: () => import("@/views/share-detail/index.vue"),
      },
      {
        path: "/cbecpda",
        name: "cbecpda",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/cbecpda/index.vue"),
      },
      {
        path: "/dataHome",
        name: "dataHome",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/dataHome/index.vue"),
      },
      {
        path: "/dataOne",
        name: "dataOne",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataOne.vue"),
      },
      {
        path: "/dataTwo",
        name: "dataTwo",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataTwo.vue"),
      },
      {
        path: "/dataBarHorizontal",
        name: "dataBarHorizontal",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataBarHorizontal.vue"),
      },
      {
        path: "/dataOrderLine",
        name: "dataOrderLine",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataOrderLine.vue"),
      },
      {
        path: "/dataOrderTable",
        name: "dataOrderTable",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataOrderTable.vue"),
      },
      {
        path: "/safroundShareOut",
        name: "safroundShareOut",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/safroundShareOut/index.vue"),
      },
      {
        path: "/safroundShare",
        name: "safroundShare",
        meta: {
          noLogin: false,
        },
        component: () => import("@/views/safroundShare/index.vue"),
      },
      {
        path: "/safroundShareHistory",
        name: "safroundShareHistory",
        meta: {
          noLogin: false,
        },
        component: () => import("@/views/safroundShareHistory/index.vue"),
      },
      {
        path: "/dataDrawCircle",
        name: "dataDrawCircle",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/charts/dataDrawCircle.vue"),
      },
      {
        path: "/pdf",
        name: "pdf",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/pdfRoot/pdfRoot.vue"),
      },
      {
        path: "/manageroot",
        name: "manageroot",
        component: () => import("@/views/manageroot/index.vue"),
      },
      {
        path: "/managerdaychoose",
        name: "managerdaychoose",
        component: () => import("@/views/managerDayChoose/index.vue"),
      },
      {
        path: "/managerday",
        name: "managerday",
        component: () => import("@/views/managerDay/index.vue"),
      },
      {
        path: "/managermonth",
        name: "managermonth",
        component: () => import("@/views/managerMonth/index.vue"),
      },
      {
        path: "/chatgpt",
        name: "chatgpt",
        component: () => import("@/views/chatgpt/index.vue"),
      },
      {
        path: "/reformdaylist",
        name: "reformdaylist",
        component: () => import("@/views/reformDayList/index.vue"),
      },
      {
        path: "/managerdaylist",
        name: "managerdaylist",
        component: () => import("@/views/managerDayList/index.vue"),
      },
      {
        path: "/managermonthlist",
        name: "managermonthlist",
        component: () => import("@/views/managerMonthList/index.vue"),
      },
      {
        path: "/safround",
        name: "safround",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/safround/index.vue"),
      },
      {
        path: "/login",
        name: "ShareLogin",
        component: () => import("@/views/login/index.vue"),
      },
      {
        path: "/year",
        name: "NewYear",
        component: () => import("@/views/newYear/index.vue"),
        meta: {
          noLogin: true,
        },
      },
      {
        path: "/privacy",
        name: "PrivacyAgreement",
        meta: {
          noLogin: true,
        },
        component: () => import("@/views/privacyAgreement/index.vue"),
      },
    ],
  },
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log("scrollBehavior:" + from)
    if (!savedPosition) {
      return {x: 0, y: 0};
    } else {
      return savedPosition;
    }
  },
});

router.beforeEach((to, from, next) => {
  // document.title = to.meta.title || '';
  // 这里先获取下用户信息，我偷懒用sessionStorage存了
  // 里面包含了用户权限，用户各种信息等
  // localStorage.removeItem('email');

  if (to.query.psnname) {
    localStorage.setItem('psnname', to.query.psnname)
  }

  if (to.query.email) {
    localStorage.setItem('email', to.query.email)
  }

  if (to.query.userToken) {
    localStorage.setItem('userToken', to.query.userToken)
  }

  if (to.query.appid) {
    localStorage.setItem('appid', to.query.appid)
  }

  const user = localStorage.getItem('email');
  // const psnname = localStorage.getItem('psnname');
  console.log(user)
  // 这里必须加上to.path !== 'login'的判断，不然会陷入无限循环，
  // 因为逻辑是第一次进来，判断用户信息不存在，即!user为true，由于使用的是next('/login')而非next()，
  // 会再次进入路由跳转，next()方法没有参数是直接进入页面，不会再次进入路由拦截，有参数则会，因为跳转，
  // 所以再次进入路由，再次判断，再次进入路由，再次判断，循环往复无限循环
  // 所以一定要加to.path !== 'login'的判断
  if (to.meta.noLogin) {
    next();
    return
  }

  if (!user && to.path !== '/login') {
    next(`/login?url=${encodeURIComponent(to.fullPath)}`);
  } else {
    if (!to.query.email && to.path !== '/login') {
      to.query.email = user
      console.log(to.query)
      console.log(to.fullPath)
      next({path: to.path, query: to.query, params: to.params});
    } else {

      if (to.path === '/managerday') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }

      if (to.path === '/managerdaylist') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }

      if (to.path === '/managermonth') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }

      if (to.path === '/managermonthlist') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }

      if (to.path === '/reformdaylist') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }

      if (to.path === '/managerdaychoose') {
        // if (persons.indexOf(psnname) < 0 && persons2.indexOf(psnname) < 0 && persons3.indexOf(psnname) < 0 && superManager.indexOf(psnname) < 0) {
        //   Notify({type: 'danger', message: '暂无权限'});
        //   return
        // }
      }
      next();
    }
  }
});

export default router;
